import { getGlobalHeadersAsObject } from "./global-headers";

export type LocationMap = {
	id: number;
	urnid: number;
	location_name: string;
	country_iso_code: number | null;
	ostmd_id: number | null;
	ostmd_name: string | null;
	ostmd_country: string | null;
	ostmd_admin_level: number | null;
};

export type OpenStreetMapsDetail = {
	id: number;
	localname: string;
	name_en: string;
	country: string;
	country_code_iso2: string;
	admin_level: number;
	category: string;
	tpe: string;
	full_osm_id: string;
};

export const getLocationMapById = (id: number): Promise<LocationMap> => {
	if (!id || typeof id !== "number") {
		throw new Error(
			`getLocationMapById called with invalid argument id '${id}'. Expected number`
		);
	}

	return fetch(`/api/v2/location_map/${id}/`, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => res.json());
};

export const getOpenStreetMapsDetailById = (
	id: number
): Promise<OpenStreetMapsDetail> => {
	if (!id || typeof id !== "number") {
		throw new Error(
			`getOpenStreetMapsDetailById called with invalid argument id '${id}'. Expected number`
		);
	}

	return fetch(`/api/v2/openstreetmapsdetail/${id}/`, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => res.json());
};
